module.exports = __webpack_public_path__ + "static/media/sales-house-icon.a02bd14b.svg";